<div class="scrollbar app ">
    <div class="border pad15 mb15">
        <div *ngIf="IsMessageDisplay && !isFromArchive" class="alert alert-danger text-center">
            <span class="font18">{{message}}</span>
        </div>
        <div style="display: flex;flex-direction: row-reverse;">
        <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
        (click)='RefreshDayData()'>
        <em class="fas fa-sync fa-lg"></em>
        </a>
        </div>
        <div id="mechanic-planner">
            <ng-container *ngIf="!isFromArchive">
                <app-af-scheduler-list [schedularHeader]="schedulerHeaderInfo" (onMonthChange)="schedulerMonthChange($event)"
                    (onDayChange)="onDayChange($event)" [genericSchedulerList]="genericSchedulerListViewModel"
                    [appointmentId]="appointmentId" [dealerWorkingHours]="dealerWorkingHours" [appointmentDate]="appointmentDate"
                    [isViewAppointment]="!isEdit" [schedulerModal]="schedulerModal" [isServicesAdded]="isServicesAdded"
                    [dealerHolidays]="dealerHolidays" (showAddBooking)="onAddBooking($event)" [selectedDate]="selectedDate"
                    (showAllMechanics)="onShowAllMechanics($event)" [isView]="isView" [isReadOnly]="false"
                    [onScrollPlanning]="dayViewScrollLeft" (onMechanicScroll)="syncMechanicScroll($event)">
                </app-af-scheduler-list>
            </ng-container>
            <ng-container *ngIf="appointmentSchedule && daySchedulerViewModel && !isFromArchive">
                <af-app-scheduler-day-view #dayViewRef [hours]="hours" [appointmentSchedule]="appointmentSchedule" [duration]="remainingDuration"
                    (showAddBooking)="onAddBooking($event)" [daySchedulerViewModel]="daySchedulerViewModel"
                    [selectedDate]="selectedDate" [schedulerModal]="schedulerModal" [dealerName]="dealerName" [isView]="isView"
                    [isReadOnly]="false" [totalServiceTime]="totalServiceTime" [totalDuration]="totalDuration"
                    [calendarNumber]="calendarNumber" [serviceDetail]="serviceDetail" (onScrollPlanning)="onDayViewScroll($event)">
                </af-app-scheduler-day-view>
            </ng-container>
            <ng-container *ngIf="appointmentSchedule && daySchedulerViewModel && !isFromArchive">
                <div class="planning-legend mt-2">
                    <!-- Row 1: Mechanic Status -->
                    <div class="pl-row">
                        <span class="pl-row-label">
                            <em class="fas fa-wrench pl-row-icon"></em>
                            <span translate>lblMechanicStatus</span>
                        </span>
                        <div class="pl-items">
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#fff; box-shadow: inset 0 0 0 1.5px #aaa;"></span>
                                <span translate>lblAvailable</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#ffffd5; border:1px solid #ccc;"></span>
                                <span translate>lblOutForLunch</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#ceff0b; border:1px solid #ccc;"></span>
                                <span translate>lblBreakTimings</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#d7d7df;"></span>
                                <span translate>lblNotAvailable</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#0380ca;"></span>
                                <span translate>lblReserveSlot</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#ecec6e; border:1px solid #ccc;"></span>
                                <span translate>lblWARPlanning</span>
                            </span>
                            <span class="pl-item">
                                <span class="pl-sq" style="background-color:#99cdba;"></span>
                                <span translate>lblTemparoryNotAvailable</span>
                            </span>
                            <span class="pl-item" *ngIf="isBlockMechanic">
                                <span class="pl-sq" style="background-color:#fc0303;"></span>
                                <span translate>lblBlockMechanic</span>
                            </span>
                        </div>
                    </div>
                    <!-- Row 2: Appointment Status -->
                    <div class="pl-row">
                        <span class="pl-row-label">
                            <em class="fas fa-calendar-alt pl-row-icon"></em>
                            <span translate>lblAppointmentStatus</span>
                        </span>
                        <div class="pl-items">
                            <span class="pl-item" *ngFor="let list of workOrderStatusList">
                                <span class="pl-sq" [style.background-color]="list.color"></span>
                                <span>{{list.status}}</span>
                            </span>
                        </div>
                    </div>
                    <!-- Row 3: Mechanic Leave Types -->
                    <div class="pl-row" *ngIf="mechanicLeaveTypesList?.length > 0">
                        <span class="pl-row-label">
                            <em class="fas fa-door-open pl-row-icon"></em>
                            <span translate>lblMechanicLeaveType</span>
                        </span>
                        <div class="pl-items">
                            <span class="pl-item" *ngFor="let leave of mechanicLeaveTypesList">
                                <span class="pl-sq" [style.background-color]="leave.colorCode" [style.border]="!leave.colorCode ? '1px solid #aaa' : 'none'"></span>
                                <span translate>{{leave.leaveLabel}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

  
    <div class="ctm-tab custom-card card-accord overflow-none mt-4">
        <ngb-accordion #a="ngbAccordion" activeIds="first" id="booked-mechanics">
            <ngb-panel id="first">
                <ng-template ngbPanelHeader class="custom-header ctm">
                    <div class="d-flex align-items-center">
                        <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                            aria-label="Center Align">
                            <span translate class="big" translate>lblBookedMechanics</span> (HH:mm)
                            <span class="font16 ml-1" id="PackageBlock">
                                (
                                <span *ngIf="!isFromArchive">
                                    <span translate>lblTotalTime</span> :
                                    <span id="totalTimevalue" class="cd-data-text-header">{{ formatedTotalServiceTimeDate |
                                        date:'HH:mm'
                                        }}</span>                               
                                <span>, </span>
                                </span>
                                <span translate> lblPlannedTime</span> :
                                <span class="cd-data-text-header">
                                    {{formattedtotalDurationDate | date:'HH:mm'}}
                                </span>

                                )
                            </span>


                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                            </ng-container>
                            <ng-container *ngIf="a.activeIds.includes('first')"><em
                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                            </ng-container>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="table-responsive tableMx-15">
                        <table class="tablest1">
                            <thead class="head-pt-0">
                                <tr>
                                    <th scope="col" translate>lblDate</th>
                                    <th scope="col" translate>lblMechanic</th>
                                    <th scope="col"><span translate>lblStart</span><br><span class="text-sm1"
                                            translate>(HH:MM)</span></th>
                                    <th scope="col"><span translate>lblEnd</span><br><span class="text-sm1"
                                            translate>(HH:MM)</span></th>
                                    <th scope="col" translate>lblEfficiency</th>
                                    <th scope="col"><span translate>lblTotalTime</span>/<span translate>lblPlannedTime</span><br><span class="text-sm1"
                                            translate>(Minutes)</span></th>
                                    <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngIf="appointmentSchedule && appointmentSchedule.bookedMechanicList && appointmentSchedule.bookedMechanicList.length > 0; else NoRecords">
                                    <tr *ngFor="let item of appointmentSchedule.bookedMechanicList; let i=index">
                                        <td>
                                            {{ item.startTime | date:'shortDate' }}
                                        </td>
                                        <td>{{ item.mechanicName }}</td>
                                        
                                        <td>{{ item.startTime | date:'HH:mm' }}</td>
                                        <td>{{ item.endTime | date:'HH:mm' }}</td>
                                        <td>{{ item.efficiency }}</td>
                                        <td>{{ item.serviceTime }} / {{ item.duration }}</td>
                                        <td class="nowrap text-center">
                                            <a ngbTooltip="{{'lblEdit' | translate}}" class="btn btn-ico" tooltipClass="custom-revert"
                                                [ngClass]="item.isDisable || isFromArchive ? 'disabled' : ''"
                                                (click)="isEdit && onEditMechanicBooking(item.bookingId, item.startDate, item.mechanicName, item.mechanicId, item.startTime, item.endTime, item.duration, item.efficiency)">
                                                <em class="fas fa-pencil-alt fa-lg"></em>
                                            </a>
                                            <span class="ico-div"></span>
                                            <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                                [ngClass]="item.isDisable || isFromArchive ? 'disabled' : ''"
                                                (click)=" isEdit && onDeleteMechanicBooking(mymodal,item.bookingId)">
                                                <em class="far fa-trash-alt fa-lg"></em>
                                            </a>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #NoRecords>
                                    <td colspan="9" class="no-record" translate>lblNoRecordsFound</td>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>
</div>
</div>

<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg mb-1" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>



<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblDelete</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false);bookingId=0;reasonForDelete=''">
            <span aria-hidden="true">×</span>
        </button>
    </div>
      
        <div class="modal-body p-0 ">
            <div class="popup-vcenter ">
                <div class="flgrow">
                    <div class="pad15">
                        <div class="form-row">
                            <div class='col-12'>
                                <label translate>lblReasonForDeletePlanning</label><strong class="mlt6 required"> * </strong>
                                <div class="">
                                    <textarea class="form-control" type="text" name="reason" 
                                        [(ngModel)]="reasonForDelete" maxlength="1000" autocomplete="off"
                                        placeholder="{{ 'lblEnterValue' | translate }}" >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" 
            [disabled]="reasonForDelete?.length === 0"
            translate (click)="deleteMechanicBooking();modal.dismiss(false)"
                aria-label="Center Align" >lblDelete</button>
            <button (click)="modal.dismiss(false);bookingId=0;reasonForDelete=''" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>
